export default "__VITE_ASSET__4f88d847__"